import { useDispatch, useSelector } from 'react-redux';

import { useEffect } from 'react';
import { optimizationPricesListSelector } from '../../../../reducers/OtimizacaoPrecos';
import { resetGridData, setPagination } from '../../../../reducers/OtimizacaoPrecos/optimizationPricesList';
import { useHandleSearchOptimization } from './useHandleSearchOptimization';

export function useGridTableActions() {
  const optimizationPricesList = useSelector(optimizationPricesListSelector);

  const { data, pagination } = optimizationPricesList;
  const { sortColumn, orderBy } = pagination;
  const dispatch = useDispatch();
  const { state } = useHandleSearchOptimization();

  const handleSetSortColumn = async (column: string, type: 'asc' | 'desc') => {
    dispatch(setPagination({ pagination: { ...pagination, sortColumn: column, orderBy: type } }));
  };

  const handleChangePage = (value: number) => {
    dispatch(setPagination({ pagination: { ...pagination, number: value - 1 } }));
  };

  const handleChangeSize = (value: number) => {
    dispatch(setPagination({ pagination: { ...pagination, size: value, number: 0 } }));
  };

  useEffect(() => {
    return () => {
      dispatch(resetGridData());
    };
  }, []);

  return {
    tableHandlers: {
      handleSetSortColumn,
      handleChangePage,
      handleChangeSize,
    },
    tableState: {
      sortColumn,
      orderBy,
      page: pagination.number,
      data,
      pagination,
      isLoadingSearchOptimizations: state.isLoadingSearchOptimizations || state.isRefetching,
    },
  };
}
